const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
if (!API_BASE_URL) {
  console.error("REACT_APP_API_BASE_URL is not set. API calls will fail.");
}

const headers = {
  Accept: "application/json",
};

export const api = {
  async getMaxRunDateTime() {
    const response = await fetch(
      `${API_BASE_URL}/v2/web/pdmax/maxrundatetime`,
      { headers }
    );
    if (!response.ok) throw new Error("Failed to fetch max run datetime");
    return response.json();
  },

  async getMaxAvailData(
    runDateTime,
    aggregationLevel = "duid",
    regionIds = []
  ) {
    const params = new URLSearchParams({
      run_datetime: runDateTime,
      aggregation_level: aggregationLevel,
    });
    if (regionIds.length > 0) {
      params.append("region_ids", regionIds.join(","));
    }
    const response = await fetch(
      `${API_BASE_URL}/v2/web/pdmax/data?${params}`,
      { headers }
    );
    if (!response.ok) throw new Error("Failed to fetch maxavail data");
    return response.json();
  },

  async getAggregationOptions(runDateTime, regionIds = []) {
    const params = new URLSearchParams({ run_datetime: runDateTime });
    if (regionIds.length > 0) {
      params.append("region_ids", regionIds.join(","));
    }
    const response = await fetch(
      `${API_BASE_URL}/v2/web/pdmax/aggregationoptions?${params}`,
      { headers }
    );
    if (!response.ok) throw new Error("Failed to fetch aggregation options");
    return response.json();
  },

  async getHierarchyTree(runDateTime, regionIds = []) {
    const params = new URLSearchParams({ run_datetime: runDateTime });
    if (regionIds.length > 0) {
      params.append("region_ids", regionIds.join(","));
    }
    const response = await fetch(
      `${API_BASE_URL}/v2/web/pdmax/hierarchytree?${params}`,
      { headers }
    );
    if (!response.ok) throw new Error("Failed to fetch hierarchy tree");
    return response.json();
  },
};
